/**
 * PROPRIETARY AND CONFIDENTIAL
 * Copyright © 2026 Contractor Co-Pilot. All Rights Reserved.
 */

import type { Primitive } from "../../state/use-url-state";

import type { FilterRecord, UrlSyncState } from "./types";

export function buildFilterUrlStatePartial<
  TFilter extends FilterRecord,
>(args: {
  shouldSyncWithUrl: boolean;
  filterKeys: (keyof TFilter & string)[];
  filterUrlKeyMap: Record<string, string>;
  filterState: Record<string, unknown>;
  sanitizedInitialFilters: Record<string, unknown>;
}): Partial<UrlSyncState> {
  const {
    shouldSyncWithUrl,
    filterKeys,
    filterUrlKeyMap,
    filterState,
    sanitizedInitialFilters,
  } = args;
  if (!shouldSyncWithUrl) {
    return {};
  }
  const result: Partial<UrlSyncState> = {};
  for (const key of filterKeys) {
    const urlKey = filterUrlKeyMap[key];
    if (!urlKey) continue;
    const value = filterState[key];
    const defaultValue = sanitizedInitialFilters[key];
    if (value === defaultValue) {
      result[urlKey] = undefined;
    } else {
      result[urlKey] = (value ?? undefined) as Primitive;
    }
  }
  return result;
}
